import { render } from "./NavbarStyleTwo.vue?vue&type=template&id=bb822d9c"
import script from "./NavbarStyleTwo.vue?vue&type=script&lang=js"
export * from "./NavbarStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__